var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c(
        "app-browse",
        {
          ref: "browse",
          attrs: {
            "data-source": _vm.dataSource,
            "selected-items": _vm.selectedItems,
            "controls-disabled": _vm.controlsDisabled,
            "is-search-only": _vm.isSearchOnly,
            "search-enabled": _vm.searchEnabled,
            "button-bar-items": _vm.buttonBarItems,
            "url-query-params": "",
          },
          on: {
            "search-item-selected": function ($event) {
              return _vm.onSearchItemSelected($event)
            },
            "prospect-to-customer": function ($event) {
              return _vm.onProspectToCustomer($event)
            },
            state: function ($event) {
              _vm.browseState = $event
            },
            "col-click-result": (result, value) =>
              _vm.onColClick(result, value),
          },
        },
        [
          _vm._t("header", null, { slot: "header" }),
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("tooltip.import-csv"),
                  expression: "$ct('tooltip.import-csv')",
                },
              ],
              attrs: { slot: "extra-buttons", disabled: !_vm.canWrite },
              on: {
                click: function ($event) {
                  _vm.uploadCSVModal = true
                },
              },
              slot: "extra-buttons",
            },
            [_c("w-fa", { attrs: { icon: "upload" } })],
            1
          ),
          _vm._t("extra-buttons", null, { slot: "extra-buttons" }),
          _vm._t("more", null, { slot: "more" }),
          _vm._t("top", null, { slot: "top" }),
          _vm._t("bottom", null, { slot: "bottom" }),
        ],
        2
      ),
      _c(
        "w-modal",
        {
          attrs: { slot: "header" },
          slot: "header",
          model: {
            value: _vm.uploadCSVModal,
            callback: function ($$v) {
              _vm.uploadCSVModal = $$v
            },
            expression: "uploadCSVModal",
          },
        },
        [
          _c("app-import-csv-modal", {
            attrs: { "group-id": _vm.browseId },
            on: {
              close: function ($event) {
                _vm.uploadCSVModal = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          staticClass: "w100",
          attrs: {
            value: _vm.$route.path != _vm.baseRoutePath,
            "full-height": "",
          },
        },
        [
          _c("router-view", {
            key: _vm.$route.path,
            on: {
              saved: function ($event) {
                return _vm.updateView()
              },
              close: function ($event) {
                return _vm.$router.push(_vm.baseRoutePath)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.sendMessageDialogContact != null } },
        [
          _vm.sendMessageDialogContact
            ? _c("app-send-message-dialog", {
                attrs: {
                  "additional-bcc": _vm.sendMessageDialogContact
                    .getAdditionalBccEmails()
                    .join(";"),
                  to: _vm.sendMessageDialogContact.getDefaultEmail(),
                },
                on: {
                  close: function ($event) {
                    return _vm.closeSendMessageDialog()
                  },
                  sent: function ($event) {
                    return _vm.closeSendMessageDialog()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }